export const GET_DOCUMENT_PENDING = 'GET_DOCUMENT_PENDING'
export const GET_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SUCCESS'
export const GET_DOCUMENT_ERROR = 'GET_DOCUMENT_ERROR'

export const GET_PAGE_PENDING = 'GET_PAGE_PENDING'
export const GET_PAGE_SUCCESS = 'GET_PAGE_SUCCESS'
export const GET_PAGE_ERROR = 'GET_PAGE_ERROR'

export const GET_TEXT_CONTENT_PENDING = 'GET_TEXT_CONTENT_PENDING'
export const GET_TEXT_CONTENT_SUCCESS = 'GET_TEXT_CONTENT_SUCCESS'
export const GET_TEXT_CONTENT_ERROR = 'GET_TEXT_CONTENT_ERROR'

export const UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER'
export const SCALE_PAGE = 'SCALE_PAGE'
export const SET_SCALE = 'SET_SCALE'

export const SET_PAGE_ROTATION = 'SET_PAGE_ROTATION'
export const APPLY_LEGACY_ROTATIONS = 'APPLY_LEGACY_ROTATIONS'

export const ALERT_ERROR = 'ALERT_ERROR'
